export default __webpack_public_path__ + "static/media/gallery_09.2c151665.jpg";